import { render, staticRenderFns } from "./F24BankCoordinatesTable.vue?vue&type=template&id=31c377e4&scoped=true"
import script from "./F24BankCoordinatesTable.vue?vue&type=script&lang=js"
export * from "./F24BankCoordinatesTable.vue?vue&type=script&lang=js"
import style0 from "./F24BankCoordinatesTable.vue?vue&type=style&index=0&id=31c377e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c377e4",
  null
  
)

export default component.exports